import { render, staticRenderFns } from "./CompanyDesktopMultiMeals.vue?vue&type=template&id=5568e306"
import script from "./CompanyDesktopMultiMeals.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports